import { useState } from "react";
import It from "../../../assets/Home-Page-Assets/It-only-gets-better.png";
import Button from "../../../components/Buttons/Button";
import { sendFormEmail } from "../../../lib/sendEmail";
import "../HireUsComponets/HireUsComponets.css";

const HireUsComponets = () => {
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    phone: "",
    where: "",
    problem: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, phone, where, problem } = formValues;

    setIsSubmitting(true);
    setError("");

    try {
      await sendFormEmail("hire", { name, email, phone, where, problem });

      window.location.href = `/confirmation?type=contact${name ? `&name=${encodeURIComponent(name)}` : ''}${email ? `&email=${encodeURIComponent(email)}` : ''}&message=${encodeURIComponent('Thank you for reaching out to us! Our team will review your inquiry and get back to you shortly.')}`;

      setFormValues({
        name: "",
        email: "",
        phone: "",
        where: "",
        problem: "",
      });
    } catch (submitError) {
      console.error("Failed to send message:", submitError);
      setError("Error sending message. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="hireUsComponets">
      <div className="container">
        <div className="form-section">
          <div className="my-6 text-center">
            <h2 className="font-bold text-[var(--navy-blue)]">
              Let&apos;s build together
            </h2>
          </div>
          <div className="form-content">
            <div className="itImage">
              <img src={It} alt="Belsoft Systems" className="w-20" />
            </div>
            <form onSubmit={handleSubmit} aria-busy={isSubmitting}>
              <div className="field-style">
                <label htmlFor="hire-name" className="label-style">
                  Name:
                </label>
                <input
                  type="text"
                  name="name"
                  id="hire-name"
                  placeholder="Type Here..."
                  className="input-style"
                  onChange={handleInputChange}
                  value={formValues.name}
                  required
                  disabled={isSubmitting}
                />
              </div>
              <div className="field-style">
                <label htmlFor="hire-email" className="label-style">
                  E-mail:
                </label>
                <input
                  type="email"
                  name="email"
                  id="hire-email"
                  placeholder="Type Here..."
                  className="input-style"
                  onChange={handleInputChange}
                  value={formValues.email}
                  required
                  disabled={isSubmitting}
                />
              </div>
              <div className="field-style">
                <label htmlFor="hire-phone" className="label-style">
                  Phone Number:
                </label>
                <input
                  type="tel"
                  name="phone"
                  id="hire-phone"
                  placeholder="Type Here..."
                  className="input-style"
                  onChange={handleInputChange}
                  value={formValues.phone}
                  required
                  disabled={isSubmitting}
                />
              </div>
              <div className="field-style">
                <label htmlFor="hire-where" className="label-style">
                  Where did you hear about us?
                </label>
                <textarea
                  name="where"
                  id="hire-where"
                  rows="5"
                  placeholder="Type Here..."
                  className="input-style"
                  onChange={handleInputChange}
                  value={formValues.where}
                  required
                  disabled={isSubmitting}
                />
              </div>
              <div className="field-style">
                <label htmlFor="hire-problem" className="label-style">
                  What project or challenge do you need solved?
                </label>
                <textarea
                  name="problem"
                  id="hire-problem"
                  rows="5"
                  placeholder="Type Here..."
                  className="input-style"
                  onChange={handleInputChange}
                  value={formValues.problem}
                  required
                  disabled={isSubmitting}
                />
              </div>
              {error && <p className="form-error" role="alert">{error}</p>}
              <div className="field-style">
                <Button text={isSubmitting ? "Sending..." : "Submit"} type="submit" disabled={isSubmitting} />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HireUsComponets;
